import miloPic from "@/public/images/artists/milo.png";
import { Artist } from "@/types/types";

export const milo = {
  id: "234",
  name: "Milo",
  image: miloPic,
  description: `Milo's voice is full of sincerity and unselfconscious energy. He isn’t afraid to belt with surprising power, bringing a charming, childlike touch to any track.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmilo-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Pop", "Kids", "Theatrical"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 62,
        high: 76,
      },
      sweetSpot: 69,
    },
  },
} as const satisfies Artist;
